export default "__VITE_ASSET__CxnWWyV0__"